// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__ILUU_","left":"InfoRow_left__1c91H"};